import lat2cyr from "./lat2cyr";
import russian from "./russian";

export default {
  lat2cyr,
  russian,
};
